import { Box, MenuItem, Modal, Stack, Typography } from "@mui/material";
import { useEffect} from "react";
import styles from "./styles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useResponsive } from "../../../../hooks/customUseResponsive";
import { ViewFeedbackQuery } from "../../../../utils/reactQuery/manager/EmployeeFeedback/ViewFeedback";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { addFeedbackSchema } from "../../../../schemas/addFeedback";
import ReactQuill from "react-quill";
import { RHFSelect } from "../../../../components/RFH/RFHselect";
import { removeHtmlTagsAndEntities } from "../../../../hooks/removehtmlTags";
import { putEditFeedback } from "../../../../services/manager/EmployeeFeedback/apiEditFeedback";
import toast from "react-hot-toast";
import { LoadingButton } from "@mui/lab";
import { RHFSingleCheckbox } from "../../../../components/RFH/RFHCheckbox";
import { isManager } from "../../../../utils/helpers";
import Loader from "../../../../components/Loader";

export default function EditFeedback({
  openProp,
  handleClose,
  id,
  employeeId,
}) {
  const queryClient = useQueryClient();
  const employeeUnderManager = queryClient.getQueryData([
    "employeeUnderManager",
  ]);
  const isMobile = useResponsive("down", "sm");
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? 330 : 808,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    scrollY: "scroll",
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [{ color: [] }, { background: [] }], // Add color and background color options
      ["link"],
      ["clean"],
    ],
  };

  const { mutate, isPending } = useMutation({
    mutationFn: putEditFeedback,
    onSuccess: (data) => {
      // console.log("put edit ", data);
      toast.success(data.data.message);
      queryClient.invalidateQueries({
        queryKey: ["employeeFeedbackList"],
      });
      queryClient.invalidateQueries({
        queryKey: ["viewFeedback", id],
      });
      handleClose();
    },
    onError: (data) => {
      console.error("error employee feedback", data);
    },
  });

  const { note, isLoading } = ViewFeedbackQuery(id);

  const methods = useForm({
    resolver: yupResolver(addFeedbackSchema),
    defaultValues: {
      employee_id: employeeId,
      feedback: "",
      is_publish: "",
    },
  });

  useEffect(() => {
    if (note) {
      console.log("note", note);
      methods.reset({
        employee_id: note?.employee_id,
        feedback: note?.description,
        is_publish: note?.is_publish,
      });
    }
  }, [employeeId, methods, note]);

  const onSubmit = (formData) => {
    // console.log("on submit edit feedback", formData);
    mutate({
      id: id,
      description: formData.feedback,
      is_publish: formData.is_publish,
    });
  };

  return (
    <Modal open={openProp} onClose={handleClose}>
      <Box sx={{ ...style }}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Stack direction="row" className={styles.header}>
              <Typography className={styles.heading}>
                Employee Feedback
              </Typography>
              <Box onClick={() => handleClose()}>
                <CloseIcon className={styles.icon} />
              </Box>
            </Stack>

            {isLoading && (
              <Stack className={styles.loaderCont}>
                <Loader />
              </Stack>
            )}

            <Box className={styles.container}>
              <Stack className={styles.contSelect}>
                <Box className={styles.flexItem}>
                  <Typography className={styles.label}>
                    Employee Name
                  </Typography>
                  <RHFSelect name="employee_id">
                    {employeeUnderManager?.data.map((ele, idx) => {
                      return (
                        <MenuItem value={ele.employee_id} key={ele.employee_id}>
                          {ele.name}
                        </MenuItem>
                      );
                    })}
                  </RHFSelect>
                </Box>
              </Stack>

              <Typography className={styles.label}>Feedback</Typography>
              <Box className={styles.textEditorCont}>
                <ReactQuill
                  value={methods.getValues("feedback")}
                  onChange={(value) =>
                    methods.setValue(
                      "feedback",
                      removeHtmlTagsAndEntities(value).length === 0 ? "" : value
                    )
                  }
                  modules={modules}
                  style={{ height: "170px" }}
                />
              </Box>
              <Typography className={styles.feedbackError}>
                {methods.formState.errors.feedback?.message}
              </Typography>

              <Stack className={styles.btnCont}>
                <RHFSingleCheckbox
                  name="is_publish"
                  label="Publish"
                  disabled={isManager() ? true : false}
                />
                <LoadingButton
                  loading={isPending}
                  type="submit"
                  className={styles.btnClass}
                  onClick={() => ""}
                  variant="contained"
                  color="primary"
                >
                  Submit
                </LoadingButton>
              </Stack>
            </Box>
          </form>
        </FormProvider>
      </Box>
    </Modal>
  );
}
